import { render } from "./MobileHeader.vue?vue&type=template&id=785a4ea1"
import script from "./MobileHeader.vue?vue&type=script&lang=js"
export * from "./MobileHeader.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3987420887/src/bt-website-2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__